import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./plr.module.css";
import api from "../../../services/api";
import { AuthContext } from "../../../context/AuthContext";
import BottomNav from "../../../components/BottomNav";
import ApiButton from "../../../components/ApiButton/ApiButton";
import BackIcon from "../../../components/BackIcon";

export default function PLR() {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const [dados, setDados] = useState([]);
    const [total, setTotal] = useState(null);

    const [semestre, setSemestre] = useState(1);
    const [ano, setAno] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);


    const [modalMes, setModalMes] = useState(false);
    const [mesSelecionado, setMesSelecionado] = useState(null);
    const [tabAtiva, setTabAtiva] = useState("detalhes");

    const [detalhes, setDetalhes] = useState([]);
    const [engajamento, setEngajamento] = useState([]);


    async function carregaEngajamento(mes) {
        try {
            setEngajamento([]);
            const response = await api.get(`/colaborador/infocolaborador/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=E&mesano=${String(mes.mes).padStart(2, '0') + ano}`);
            setEngajamento(response.data);
        }
        catch (error) {
            console.log("Erro ao carregar Engajamento", error)
        }
    }



    async function carregarDetalhes(mes) {
        try {

            setDetalhes([]);
            let temp = [];

            const response = await api.get(`/colaborador/infocolaborador/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=Z&mesano=${String(semestre) + ano}`);


            if (response.data[0].equclt > 0 || response.data[0].equpjs > 0) {
                response.data.map((item) => {
                    if (mes.mescal === item.nommes) {
                        temp.push(
                            { label: "Planej./Desemp.", valor: item.plaper },
                            { label: "Equipe CLT", valor: item.equclt },
                            { label: "Equipe PJ", valor: item.equpjs },
                            { label: "NPS Gestor", valor: item.NPSges },
                            { label: "NPS Sucessor", valor: item.NPSsuc },
                            { label: "Pesquisas", valor: item.pesext },
                            { label: "Gestão de Horas", valor: item.geshor },
                            { label: "Gestão de Experiência", valor: item.gesexp },
                            { label: "Engajamento", valor: item.parper },
                            { label: "***Total Indiv.", valor: item.conind + '%' }
                        );
                    }
                })
            }

            else if (user.tipfun === 'T') {
                response.data.map((item) => {
                    if (mes.mescal === item.nommes) {
                        temp.push(
                            { label: "Planej./Desemp.", valor: item.plaper },
                            { label: "Engajamento", valor: item.parper },
                            { label: "***Total Indiv.", valor: item.conind + '%' }
                        );
                    }
                })
            }
            else {
                response.data.map((item) => {
                    if (mes.mescal === item.nommes) {
                        temp.push(
                            { label: "Produtividade", valor: item.procoz },
                            { label: "HOS", valor: item.hosper },
                            { label: "Assiduidade", valor: item.falper },
                            { label: "Advertência", valor: item.advper },
                            { label: "Engajamento", valor: item.parper },
                            { label: "Planej./Desemp.", valor: item.plaper },
                            { label: "Vou de Bike", valor: item.gbikper },
                            { label: "Horas Disponíveis", valor: item.tothor },
                            { label: "Horas Trabalhadas", valor: item.hortra }
                        );
                    }
                })
            }

            setDetalhes(temp);



        } catch (error) {
            console.error("Erro ao carregar Detalhes", error);
        }
    }

    function abrirMes(item) {
        carregarDetalhes(item);
        carregaEngajamento(item)
        setMesSelecionado(item);
        setTabAtiva("detalhes");
        setModalMes(true);
    }

    useEffect(() => {
        carregarPLR();
    }, [semestre, ano]);

    async function carregarPLR() {
        try {

            const response = await api.get(`/colaborador/infocolaborador/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=P&mesano=${String(semestre) + ano}`);

            const lista = response.data || [];

            const meses = lista.filter(item => item.mescal !== "TOTAL");
            const totalItem = lista.find(item => item.mescal === "TOTAL");

            setDados(meses);
            setTotal(totalItem || null);

        } catch (error) {
            console.error("Erro ao carregar PLR", error);
        }
    }

    const visualizarPDF = async () => {
        // Abre a aba em branco de forma síncrona (ainda dentro do gesto de clique do
        // usuário) e só depois troca a URL pro blob assim que o PDF chega - se
        // esperasse o fetch terminar pra chamar window.open, o navegador (principalmente
        // mobile) trata como popup não solicitado e bloqueia.
        const pdfWindow = window.open('', '_blank');
        try {
            setPdfLoading(true);

            const response = await api.get(`/colaborador/holerite/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=P&mesano=${String(semestre) + ano}`, {

                responseType: "blob"
            });

            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );

            if (pdfWindow) {
                pdfWindow.location.href = url;
            } else {
                alert("Permita pop-ups pra visualizar o PDF");
            }

        } catch (error) {
            if (pdfWindow) pdfWindow.close();
            let msg = "Erro ao gerar PDF";
            try {
                if (error.response?.data instanceof Blob) {
                    const texto = await error.response.data.text();
                    const json = JSON.parse(texto);
                    if (json.msg) msg = json.msg;
                } else if (error.response?.data?.msg) {
                    msg = error.response.data.msg;
                }
            } catch {
                // corpo do erro não veio em JSON legível - mantém a mensagem genérica
            }
            console.error(error);
            alert(msg);
        } finally {
            setPdfLoading(false);
        }
    };

    function proximo() {
        if (semestre === 1) {
            setSemestre(2);
        } else {
            setSemestre(1);
            setAno(ano + 1);
        }
    }

    function anterior() {
        if (semestre === 2) {
            setSemestre(1);
        } else {
            setSemestre(2);
            setAno(ano - 1);
        }
    }

    function formatMoney(valor) {
        return Number(valor || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }

    const plrCalculado = total
        ? (total.salbas * total.pertot) / 100 - total.destot
        : 0;

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.header}>
                <button className={styles.btnVoltar} onClick={() => navigate(-1)}><BackIcon /></button>
                <div className={styles.headerTexto}>
                    <h2>PLR</h2>
                    <p>Acompanhe seu PLR semestral</p>
                </div>
            </div>

            {/* NAVEGAÇÃO */}
            <div className={styles.card}>
                <span className={styles.cardTitulo}>📅 Período</span>
                <div className={styles.navRow}>
                    <ApiButton className={styles.btnNav} onClick={anterior}>‹ Anterior</ApiButton>
                    <span className={styles.semestreLabel}>{semestre}º Semestre / {ano}</span>
                    <ApiButton className={styles.btnNav} onClick={proximo}>Próximo ›</ApiButton>
                </div>
            </div>

            {/* MESES */}
            {dados.length > 0 && (
                <div className={styles.card}>
                    <span className={styles.cardTitulo}>📋 Meses</span>
                    <div className={styles.listaMeses}>
                        {dados.map((item, index) => {
                            const pct = item.percal;
                            const cls = pct >= 80 ? styles.percentualBom : pct >= 50 ? styles.percentualMed : styles.percentualRuim;
                            return (
                                <div key={index} className={styles.linhaMes} onClick={() => abrirMes(item)}>
                                    <span className={styles.mes}>{item.mescal}</span>
                                    <span className={cls}>{pct.toFixed(2)} %</span>
                                    <span className={styles.setaLinha}>›</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* RESUMO TOTAL */}
            {total && (
                <div className={styles.card}>
                    <span className={styles.cardTitulo}>💰 Resumo do semestre</span>
                    <div className={styles.resumoItem}>
                        <span>Salário Base</span>
                        <strong>{formatMoney(total.salbas)}</strong>
                    </div>
                    <div className={styles.resumoItem}>
                        <span>Percentual Total</span>
                        <strong>{total.pertot.toFixed(2)} %</strong>
                    </div>
                    <div className={styles.resumoItem}>
                        <span>Descontos</span>
                        <strong>{formatMoney(total.destot)}</strong>
                    </div>
                    <div className={styles.resumoTotal}>
                        <span>Líquido a Receber</span>
                        <span>{formatMoney(plrCalculado)}</span>
                    </div>
                    <ApiButton className={styles.btnPreview} onClick={visualizarPDF} disabled={pdfLoading}>
                        {pdfLoading ? "Gerando PDF..." : "Visualizar PDF"}
                    </ApiButton>
                </div>
            )}

            {/* MODAL MÊS */}
            {modalMes && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalTabs}>
                        <div className={styles.modalMesHeader}>
                            <span>{mesSelecionado?.mescal} — {mesSelecionado?.percal.toFixed(2)} %</span>
                            <button className={styles.btnFechar} onClick={() => setModalMes(false)}>✕</button>
                        </div>
                        <div className={styles.tabs}>
                            <button className={tabAtiva === "detalhes" ? styles.tabActive : styles.tab} onClick={() => setTabAtiva("detalhes")}>Detalhes</button>
                            <button className={tabAtiva === "engajamento" ? styles.tabActive : styles.tab} onClick={() => setTabAtiva("engajamento")}>Engajamento</button>
                        </div>
                        <div className={styles.tabContent}>
                            {tabAtiva === "detalhes" && detalhes.map((item, i) => (
                                <div key={i} className={styles.infoLinha}>
                                    <span>{item.label}</span>
                                    <strong>{item.valor}</strong>
                                </div>
                            ))}
                            {tabAtiva === "engajamento" && engajamento.length > 0 && (
                                <div>
                                    <div className={styles.engHeader}>
                                        <span>HP: {engajamento[0].horpos}</span>
                                        <span>HC: {engajamento[0].hortot}</span>
                                        <span>PLR: {engajamento[0].parper} %</span>
                                    </div>
                                    {engajamento.map((item, i) => (
                                        <div key={i} className={styles.infoLinha2}>
                                            <span>{item.foceng1}</span>
                                            <strong>{item.horeng}</strong>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <BottomNav />
        </div>
    );
}